import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconVibeCoding2: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconVibeCoding2"><Path d="M17.4 3H16.6L15.6 5.6L13 6.6V7.4L15.6 8.4L16.6 11H17.4L18.4 8.4L21 7.4V6.6L18.4 5.6L17.4 3Z" fill="currentColor"/><Path d="M9.5 4.5L2 12L9.5 19.5" stroke="currentColor" strokeLinecap="square"/><Path d="M22 12L14.5 19.5" stroke="currentColor" strokeLinecap="square"/></CentralIconBase>;
});

export default IconVibeCoding2;
